import { call, put, takeLatest } from "redux-saga/effects";
import { validationActions } from "./index";
import request from "utils/request";
import { showToast } from "components/ToastContainer/index";

function* validateEmailSaga(action) {
  try {
    const response = yield call(request, "/api/validate-email", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(action.payload)
    });

    if (!response?.success) {
      yield put(
        validationActions.validateEmailFailure(
          response?.message || "Email validation failed"
        )
      );
      return;
    }

    yield put(validationActions.validateEmailSuccess());
    showToast(response?.message || "Email Validated Success", "success");
  } catch (error) {
    yield put(
      validationActions.validateEmailFailure(
        error?.response?.data?.message ||
          error?.message ||
          "Email validation failed"
      )
    );
  }
}

export function* validationSaga() {
  yield takeLatest(validationActions.validateEmail.type, validateEmailSaga);
}
